import React, { useMemo } from "react"
import { Box, makeStyles, Typography } from "@material-ui/core"
import { DiscountType, IMonetaryAmount, OfferDetails, OfferDisplayLabelType } from "shared/Types/appTypes"
import { toDinero } from "shared/Helpers/CurrencyHelper"
import { useMoney } from "shared/Modules/Localization/useMoney"

type OldNewPriceProps = Readonly<{
    price?: IMonetaryAmount
    offerDetails?: OfferDetails
    renderPrice: (price: string) => React.ReactNode
}>

const useStyles = makeStyles(() => ({
    priceRow: {
        display: "flex",
        alignItems: "baseline",
        gap: "0.5rem",
    },
    oldPrice: {
        color: "#64748B",
        textDecoration: "line-through",
    },
    newPriceWithDiscount: {
        color: "#DC2626",
    },
}))

export function useOldNewPrice(price?: IMonetaryAmount, offerDetails?: OfferDetails) {
    const moneyFactory = useMoney()

    return useMemo(() => {
        if (!price) return null

        const discount = offerDetails?.discount

        if (
            discount?.displayLabelType === OfferDisplayLabelType.OLD_NEW_PRICE &&
            discount?.type === DiscountType.DISCOUNT_PRICE &&
            discount?.originalPrice
        ) {
            return {
                price: price.formatted,
                oldPrice: moneyFactory.format(toDinero(discount.originalPrice)),
            }
        }
        return { price: price.formatted }
    }, [moneyFactory, price, offerDetails])
}

export function OldNewPrice({ price, offerDetails, renderPrice }: OldNewPriceProps) {
    const classes = useStyles()
    const oldNewPrice = useOldNewPrice(price, offerDetails)

    if (!oldNewPrice) return null

    if (oldNewPrice.oldPrice) {
        return (
            <Box className={classes.priceRow}>
                <Typography variant="body2" className={classes.newPriceWithDiscount}>
                    {oldNewPrice.price}
                </Typography>
                <Typography variant="body2" className={classes.oldPrice}>
                    {oldNewPrice.oldPrice}
                </Typography>
            </Box>
        )
    }

    return <>{renderPrice(oldNewPrice.price)}</>
}
